export default __webpack_public_path__ + "static/media/list.d567dde7.png";